import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import Mode from "./mode/rtlmode";
import uploadMediaReducer from "./reducers/uploadMediaReducer";
import storage from "redux-persist/lib/storage";
import { persistStore } from "redux-persist";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
const persistConfig = {
  key: "counter",
  storage,
  blacklist: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
};
const reducers = combineReducers({
  mode: Mode,
  uploadMediaReducer: uploadMediaReducer,
});
const persistedReducer = persistReducer(persistConfig, reducers);
const middleware = [thunk];
const store = createStore(persistedReducer, applyMiddleware(...middleware));
const persistor = persistStore(store);

export default store;
export { persistor };
